<template>
  <div class="sld_Business_o">
    <NavTopBar />
    <div class="sld_Business_bodyer">
      <div class="update-container">
        <!-- 页面标题 -->
        <div class="update-header">
          <div class="update-title">经营信息更新</div>
        </div>

        <!-- 加载中 -->
        <div class="loading-container" v-if="loading">
          <p>加载中...</p>
        </div>

        <!-- 错误提示 -->
        <div class="error-container" v-if="errorMsg">
          <p>{{ errorMsg }}</p>
          <div class="submit" @click="getUpdateCompare">重新加载</div>
        </div>

        <template v-if="!loading && !errorMsg">
          <!-- 企业信息卡片 -->
          <div class="enterprise-card">
            <div class="enterprise-item">
              <span class="label"><span style="color: red">*</span> 企业全称：</span>
              <input
                class="enterprise-input"
                type="text"
                maxlength="40"
                placeholder="请输入企业全称"
                v-model="enterpriseName"
              />
            </div>
            <div class="enterprise-item">
              <span class="label"><span style="color: red">*</span> 所在地区：</span>
              <el-cascader
                class="region-cascader"
                ref="cascaderAddr"
                v-model="memberListInfo.area"
                :options="areaDataArray"
                placeholder="请选择所在地区"
                :props="cascaderProps"
              />
            </div>
            <div
              class="enterprise-item"
              v-if="enterpriseTypeId == '13' || enterpriseTypeId == '14' || enterpriseTypeId == '15'"
            >
              <span class="label"><span style="color: red">*</span> 详细地址：</span>
              <input
                class="enterprise-input"
                type="text"
                maxlength="40"
                placeholder="请输入详细地址"
                v-model="memberListInfo.addressDetail"
              />
            </div>
            <div
              class="enterprise-item"
              v-if="enterpriseTypeId == '11' || enterpriseTypeId == '12'"
            >
              <span class="label">详细地址：</span>
              <input
                class="enterprise-input address-disabled"
                type="text"
                maxlength="40"
                placeholder="本栏默认为药品经营许可证上的仓库地址或注册地址，无需填写"
                disabled
                v-model="memberListInfo.addressDetail"
              />
            </div>
            <div class="enterprise-item enterprise-item-block">
              <span class="label"><span style="color: red">*</span> 本次修改说明：</span>
              <textarea
                class="remark-textarea"
                placeholder="请输入本次修改内容..."
                v-model="thisRemark"
                maxlength="200"
              ></textarea>
            </div>
          </div>

          <!-- 提示条 -->
          <div class="update-tip">
            <span class="tip-icon">⚠️</span>
            <span>请确保上传图片能够清晰辨识名称、地址、日期、证号等关键信息，以免因核对失败耽误您的宝贵时间。</span>
          </div>

          <!-- 资质对照卡片列表 -->
          <div class="qualification-list">
            <div
              class="qualification-card"
              v-for="(item, index) in qualificationList"
              :key="item.name"
            >
              <!-- 卡片头部 -->
              <div class="card-header">
                <div class="card-title">
                  <span class="required-star" v-if="item.isRequired == 1">*</span>
                  <span v-html="item.name.replace('（', '<br>（')"></span>
                </div>
                <div class="card-header-right">
                  <!-- 模板链接 -->
                  <span
                    class="tem_cla"
                    v-if="item.formatType == 1 && item.template"
                    @click="go_tem(item.template)"
                  >案例模版</span>
                  <!-- 审核状态标签（退回模式） -->
                  <span class="status-tag approved" v-if="item.auditStatus == 1">✓ 审核通过</span>
                  <span class="status-tag rejected" v-if="item.auditStatus == 2">✗ 审核退回</span>
                </div>
              </div>

              <!-- 退回原因 -->
              <div class="reject-reason" v-if="item.auditStatus == 2 && item.auditComment">
                退回原因：{{ item.auditComment }}
              </div>

              <!-- 对比区域 -->
              <div class="compare-body">
                <!-- 老信息列 -->
                <div class="old-section">
                  <div class="section-label">　</div>
                  <div class="old-value-box">
                    <!-- formatType=1: 图片 -->
                    <el-image
                      v-if="item.formatType == 1 && item.oldValue2"
                      :src="item.oldValue2"
                      :preview-src-list="[item.oldValue2]"
                      fit="cover"
                      style="max-width: 100%; max-height: 200px; border-radius: 4px;"
                    />
                    <span v-if="item.formatType == 1 && !item.oldValue2" class="empty-text">暂无</span>
                    <!-- formatType=2: 文本 -->
                    <span v-if="item.formatType == 2">{{ item.oldValue1 || '暂无' }}</span>
                    <!-- formatType=3: 日期 -->
                    <span v-if="item.formatType == 3">
                      {{ item.oldFlag ? '长期' : item.oldValue2 || '暂无' }}
                    </span>
                  </div>
                </div>

                <!-- 新信息列 -->
                <div class="new-section">
                  <div class="section-label">变更后</div>

                  <!-- formatType=1: 图片 -->
                  <div
                    class="new-value-box"
                    :class="{ 'has-value': item.newValue2, 'locked': item.auditStatus == 1 }"
                    v-if="item.formatType == 1"
                  >
                    <el-image
                      v-if="item.newValue2"
                      :src="item.newValue2"
                      :preview-src-list="[item.newValue2]"
                      fit="cover"
                      style="max-width: 100%; max-height: 200px; border-radius: 4px;"
                    />
                    <div class="upload-placeholder" v-if="!item.newValue2 && item.auditStatus != 1">
                      <span class="plus-icon">+</span>
                      <span>点击更新</span>
                    </div>
                    <input
                      type="file"
                      name="check_img_url"
                      @change="changepic($event, index, false, -1)"
                      v-if="item.auditStatus != 1"
                    />
                    <img
                      src="@/assets/order/close.png"
                      alt=""
                      class="close-img"
                      v-if="item.newValue2 && item.auditStatus != 1"
                      @click="close_img(index, false, -1)"
                    />
                    <div class="lock-overlay" v-if="item.auditStatus == 1">🔒</div>
                  </div>

                  <!-- formatType=2: 文本 -->
                  <div class="new-value-box" :class="{ 'locked': item.auditStatus == 1 }" v-if="item.formatType == 2">
                    <input
                      type="text"
                      class="text-input"
                      maxlength="30"
                      :placeholder="'请输入' + item.name"
                      v-model="item.newValue1"
                      :disabled="item.auditStatus == 1"
                    />
                  </div>

                  <!-- formatType=3: 日期 -->
                  <div class="new-value-box date-box" :class="{ 'locked': item.auditStatus == 1 }" v-if="item.formatType == 3">
                    <template v-if="item.auditStatus != 1">
                      <el-config-provider :locale="locale">
                        <el-date-picker
                          v-model="item.newValue2"
                          type="date"
                          placeholder="选择日期"
                          style="width: 200px"
                          value-format="YYYY-MM-DD"
                          @change="cardInp($event, index, false, -1)"
                          :locale="locale"
                          :disabled-date="disabledDate"
                        />
                      </el-config-provider>
                      <el-checkbox
                        size="large"
                        @change="aptit_radio($event, index, false, -1)"
                        v-model="item.newFlag"
                      >长期</el-checkbox>
                    </template>
                    <template v-else>
                      <span>{{ item.newFlag ? '长期' : item.newValue2 || '--' }}</span>
                    </template>
                  </div>
                </div>
              </div>

              <!-- 子资质项 -->
              <div
                class="child-section"
                v-for="(child, childIndex) in item.children"
                :key="child.name"
              >
                <div class="child-header">
                  <div class="child-label">
                    <span class="required-star" v-if="child.isRequired == 1">*</span>
                    {{ child.name }}
                  </div>
                  <div class="child-header-right">
                    <span class="status-tag approved" v-if="child.auditStatus == 1">✓ 审核通过</span>
                    <span class="status-tag rejected" v-if="child.auditStatus == 2">✗ 审核退回</span>
                  </div>
                </div>
                <div class="reject-reason" v-if="child.auditStatus == 2 && child.auditComment">
                  退回原因：{{ child.auditComment }}
                </div>
                <div class="compare-body">
                  <!-- 老信息 -->
                  <div class="old-section">
                    <div class="section-label">　</div>
                    <div class="old-value-box">
                      <el-image
                        v-if="child.formatType == 1 && child.oldValue2"
                        :src="child.oldValue2"
                        :preview-src-list="[child.oldValue2]"
                        fit="cover"
                        style="max-width: 100%; max-height: 200px; border-radius: 4px;"
                      />
                      <span v-if="child.formatType == 1 && !child.oldValue2" class="empty-text">暂无</span>
                      <span v-if="child.formatType == 2">{{ child.oldValue1 || '暂无' }}</span>
                      <span v-if="child.formatType == 3">
                        {{ child.oldFlag ? '长期' : child.oldValue2 || '暂无' }}
                      </span>
                    </div>
                  </div>
                  <!-- 新信息 -->
                  <div class="new-section">
                    <div class="section-label">变更后</div>
                    <div
                      class="new-value-box"
                      :class="{ 'has-value': child.newValue2, 'locked': child.auditStatus == 1 }"
                      v-if="child.formatType == 1"
                    >
                      <el-image
                        v-if="child.newValue2"
                        :src="child.newValue2"
                        :preview-src-list="[child.newValue2]"
                        fit="cover"
                        style="max-width: 100%; max-height: 200px; border-radius: 4px;"
                      />
                      <div class="upload-placeholder" v-if="!child.newValue2 && child.auditStatus != 1">
                        <span class="plus-icon">+</span>
                        <span>点击更新</span>
                      </div>
                      <input
                        type="file"
                        @change="changepic($event, index, true, childIndex)"
                        v-if="child.auditStatus != 1"
                      />
                      <img
                        src="@/assets/order/close.png"
                        alt=""
                        class="close-img"
                        v-if="child.newValue2 && child.auditStatus != 1"
                        @click="close_img(index, true, childIndex)"
                      />
                      <div class="lock-overlay" v-if="child.auditStatus == 1">🔒</div>
                    </div>
                    <div class="new-value-box" :class="{ 'locked': child.auditStatus == 1 }" v-if="child.formatType == 2">
                      <input
                        type="text"
                        class="text-input"
                        maxlength="30"
                        :placeholder="'请输入' + child.name"
                        v-model="child.newValue1"
                        :disabled="child.auditStatus == 1"
                      />
                    </div>
                    <div class="new-value-box date-box" :class="{ 'locked': child.auditStatus == 1 }" v-if="child.formatType == 3">
                      <template v-if="child.auditStatus != 1">
                        <el-config-provider :locale="locale">
                          <el-date-picker
                            v-model="child.newValue2"
                            type="date"
                            placeholder="选择日期"
                            style="width: 200px"
                            value-format="YYYY-MM-DD"
                            @change="cardInp($event, index, true, childIndex)"
                            :locale="locale"
                            :disabled-date="disabledDate"
                          />
                        </el-config-provider>
                        <el-checkbox
                          size="large"
                          @change="aptit_radio($event, index, true, childIndex)"
                          v-model="child.newFlag"
                        >长期</el-checkbox>
                      </template>
                      <template v-else>
                        <span>{{ child.newFlag ? '长期' : child.newValue2 || '--' }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 提交按钮 -->
          <div class="submit-section">
            <div
              class="submit-btn"
              :class="{ 'disabled': gologin_flag }"
              @click="submit"
            >
              {{ gologin_flag ? '提交中...' : '提 交 更 新' }}
            </div>
            <div class="submit-tip">提交后将进入审核流程，请仔细核对信息</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ElConfigProvider } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import NavTopBar from "../../../components/NavTopBar.vue";
import { ref, getCurrentInstance, onMounted, reactive } from "vue";
import { apiUrl, imageDomain } from "../../../utils/config";
import areaData from "../../../assets/area.json";
import axios from "axios";
import { useRouter } from "vue-router";

export default {
  name: "BusinessInfoUpdate",
  components: {
    NavTopBar,
    [ElConfigProvider.name]: ElConfigProvider,
  },

  setup() {
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const locale = zhCn;

    // 基础状态
    const loading = ref(false);
    const errorMsg = ref('');
    const gologin_flag = ref(false);

    // 企业信息
    const enterpriseName = ref('');
    const enterpriseTypeName = ref('');
    const enterpriseTypeId = ref('');
    const memberEnterpriseId = ref('');
    const qualificationState = ref('');

    // 收货地址信息
    const cascaderAddr = ref(null);
    const cascaderProps = { label: "regionName", value: "regionCode" };
    const areaDataArray = areaData;
    const memberListInfo = reactive({
      receiveName: '',
      contactMobile: '',
      addressDetail: '',
      area: [],
    });

    // 资质列表
    const qualificationList = ref([]);

    // 修改说明
    const thisRemark = ref('');

    // 日期选择器：禁止未来日期
    const disabledDate = (time) => {
      return time.getTime() > Date.now();
    };

    // 变更检测
    const isChanged = (item) => {
      if (item.formatType == 1) {
        return item.newValue1 && item.newValue1 !== item.oldValue1;
      }
      if (item.formatType == 2) {
        return item.newValue1 && item.newValue1 !== item.oldValue1;
      }
      if (item.formatType == 3) {
        if (item.newFlag !== item.oldFlag) return true;
        if (!item.newFlag && item.newValue2 !== item.oldValue2) return true;
        return false;
      }
      return false;
    };

    // 图片完整 URL：短路径 → 完整 URL（域名统一取 config.js 的 imageDomain，避免新旧不一致）
    const toFullImageUrl = (shortPath) => {
      if (!shortPath) return '';
      if (/^https?:\/\//.test(shortPath)) return shortPath; // 已是完整 URL 直接返回
      const domain = imageDomain.replace(/\/+$/, '');
      return domain + (shortPath.startsWith('/') ? shortPath : '/' + shortPath);
    };

    // 构建提交数据（含格式转换）
    const buildItem = (item) => {
      const base = {
        qualificationName: item.name,
        formatType: item.formatType,
      };
      if (item.formatType === 3) {
        return {
          ...base,
          oldValue1: item.oldFlag ? '' : item.oldValue2,
          oldValue2: item.oldFlag ? '长期' : '',
          newValue1: item.newFlag ? '' : item.newValue2,
          newValue2: item.newFlag ? '长期' : '',
        };
      }
      return {
        ...base,
        oldValue1: item.oldValue1,
        // 图片：value2 必须与 value1 指向同一张图，统一用 value1 推导完整 URL
        oldValue2: item.formatType === 1 ? toFullImageUrl(item.oldValue1) : (item.oldValue2 || ''),
        newValue1: item.newValue1,
        newValue2: item.formatType === 1 ? toFullImageUrl(item.newValue1) : (item.newValue2 || ''),
      };
    };

    // 获取更新对比数据
    const getUpdateCompare = () => {
      loading.value = true;
      errorMsg.value = '';
      proxy
        .$post("/v3/member/front/memberEnterPrise/apply/updateCompare")
        .then((res) => {
          if (res.state == 200) {
            const data = res.data;
            enterpriseName.value = data.enterpriseName || '';
            enterpriseTypeName.value = data.enterpriseTypeName || '';
            enterpriseTypeId.value = data.enterpriseTypeId || '';
            memberEnterpriseId.value = data.memberEnterpriseId;
            qualificationState.value = data.enterpriseQualificationState;

            // 解析收货地址信息
            if (data.memberReceiveAddressOa) {
              memberListInfo.receiveName = data.memberReceiveAddressOa.receiveName || '';
              memberListInfo.contactMobile = data.memberReceiveAddressOa.receiveTel || '';
              memberListInfo.addressDetail = data.memberReceiveAddressOa.detailAddress || '';
              memberListInfo.area = [
                data.memberReceiveAddressOa.provinceCode || '',
                data.memberReceiveAddressOa.cityCode || '',
                data.memberReceiveAddressOa.districtCode || '',
              ];
            }

            // 解析 updateCompareJson（退回模式）
            const compareMap = {};
            const compareJson = data.updateCompareJson;
            if (compareJson) {
              const compareList = typeof compareJson === 'string'
                ? JSON.parse(compareJson)
                : compareJson;
              compareList.forEach((item) => {
                if (item.formatType === 3) {
                  const isLongTerm = item.newValue2 === '长期';
                  compareMap[item.qualificationName] = {
                    ...item,
                    newValue1: isLongTerm ? '2' : '1',
                    newValue2: isLongTerm ? '' : (item.newValue1 || ''),
                  };
                } else {
                  compareMap[item.qualificationName] = item;
                }
              });
            }

            // 构建资质列表
            const oldList = data.memberQualificationListDynamic || [];
            qualificationList.value = oldList.map((item) => {
              const compare = compareMap[item.enterpriseQualificationName] || null;

              return {
                name: item.enterpriseQualificationName,
                formatType: item.formatType,
                isRequired: item.isRequired,
                oldValue1: item.value1 || '',
                oldValue2: item.value2 || '',
                oldFlag: item.formatType == 3 && item.value1 == 2,
                template: item.template || '',

                newValue1: compare
                  ? compare.newValue1
                  : (item.formatType == 3 ? '1' : ''),
                newValue2: compare ? compare.newValue2 : '',
                newFlag: compare ? (compare.newValue1 == '2') : false,

                auditStatus: compare ? compare.auditStatus : 0,
                auditComment: compare ? compare.auditComment : '',

                children: (item.memberSupplyDTOList || []).map((child) => {
                  const childCompare = compareMap[child.enterpriseQualificationName] || null;
                  return {
                    name: child.enterpriseQualificationName,
                    formatType: child.formatType,
                    isRequired: child.isRequired,
                    oldValue1: child.value1 || '',
                    oldValue2: child.value2 || '',
                    oldFlag: child.formatType == 3 && child.value1 == 2,
                    newValue1: childCompare
                      ? childCompare.newValue1
                      : (child.formatType == 3 ? '1' : ''),
                    newValue2: childCompare ? childCompare.newValue2 : '',
                    newFlag: childCompare ? (childCompare.newValue1 == '2') : false,
                    auditStatus: childCompare ? childCompare.auditStatus : 0,
                    auditComment: childCompare ? childCompare.auditComment : '',
                  };
                }),
              };
            });
          } else {
            errorMsg.value = res.msg || '获取经营信息失败';
          }
        })
        .catch(() => {
          errorMsg.value = '获取经营信息失败，请稍后重试';
        })
        .finally(() => {
          loading.value = false;
        });
    };

    // 上传图片
    const changepic = (e, index, isChild, childIndex) => {
      const file = e.target.files[0];
      if (!file) return;

      if (file.size >= Math.pow(1024, 2) * 30) {
        ElMessage.warning("图像应小于30MB");
        return;
      }
      if (file.type.indexOf("image/") !== 0) {
        ElMessage.warning("请上传图片格式！");
        return;
      }

      const data = new FormData();
      data.append("file", file);
      data.append("source", "headImg");
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      const url = apiUrl + "/v3/oss/common/upload";

      axios.post(url, data, config).then((res) => {
        if (res.status === 200) {
          ElMessage.success("上传图片成功");
          const path = res.data.data.path;
          const fullUrl = res.data.data.url || toFullImageUrl(path);
          if (isChild) {
            qualificationList.value[index].children[childIndex].newValue1 = path;
            qualificationList.value[index].children[childIndex].newValue2 = fullUrl;
          } else {
            qualificationList.value[index].newValue1 = path;
            qualificationList.value[index].newValue2 = fullUrl;
          }
        } else {
          ElMessage.warning("上传图片失败");
        }
      });
    };

    // 删除图片
    const close_img = (index, isChild, childIndex) => {
      if (isChild) {
        qualificationList.value[index].children[childIndex].newValue1 = '';
        qualificationList.value[index].children[childIndex].newValue2 = '';
      } else {
        qualificationList.value[index].newValue1 = '';
        qualificationList.value[index].newValue2 = '';
      }
    };

    // 选择日期
    const cardInp = (e, index, isChild, childIndex) => {
      if (e) {
        if (isChild) {
          qualificationList.value[index].children[childIndex].newValue1 = '1';
          qualificationList.value[index].children[childIndex].newFlag = false;
          qualificationList.value[index].children[childIndex].newValue2 = e;
        } else {
          qualificationList.value[index].newValue1 = '1';
          qualificationList.value[index].newFlag = false;
          qualificationList.value[index].newValue2 = e;
        }
      }
    };

    // 长期勾选
    const aptit_radio = (val, index, isChild, childIndex) => {
      if (isChild) {
        const child = qualificationList.value[index].children[childIndex];
        if (val) {
          child.newValue1 = '2';
          child.newValue2 = '';
          child.newFlag = true;
        } else {
          child.newFlag = false;
          child.newValue1 = '1';
        }
      } else {
        const item = qualificationList.value[index];
        if (val) {
          item.newValue1 = '2';
          item.newValue2 = '';
          item.newFlag = true;
        } else {
          item.newFlag = false;
          item.newValue1 = '1';
        }
      }
    };

    // 模板链接
    const go_tem = (url) => {
      window.open(url);
    };

    // 提交
    const submit = () => {
      if (gologin_flag.value) return;

      // 校验：企业全称
      if (!enterpriseName.value || enterpriseName.value.trim() == '') {
        ElMessage.warning("请填写企业全称！");
        return;
      }

      // 校验：所在地区
      if (memberListInfo.area.length == 0) {
        ElMessage.warning("请选择所在地区！");
        return;
      }

      // 校验：详细地址（企业类型 13/14/15 必填）
      if (
        (enterpriseTypeId.value == '13' || enterpriseTypeId.value == '14' || enterpriseTypeId.value == '15') &&
        (!memberListInfo.addressDetail || memberListInfo.addressDetail.trim() == '')
      ) {
        ElMessage.warning("请填写详细地址！");
        return;
      }

      // 校验：本次修改说明
      if (!thisRemark.value || thisRemark.value.trim() == '') {
        ElMessage.warning("请填写本次修改说明！");
        return;
      }

      // 校验：至少有一项变更
      let hasChange = false;
      qualificationList.value.forEach((item) => {
        if (isChanged(item)) hasChange = true;
        item.children.forEach((child) => {
          if (isChanged(child)) hasChange = true;
        });
      });
      if (!hasChange) {
        ElMessage.warning("请至少修改一项资质信息");
        return;
      }

      // 校验：变更项的必填字段
      const validateItem = (item) => {
        if (item.isRequired != 1) return true;
        if (item.formatType == 2) {
          if (!item.newValue1 || item.newValue1.trim().length == 0) {
            ElMessage.warning("请填写" + item.name);
            return false;
          }
        }
        if (item.formatType == 3) {
          if (!item.newFlag && (!item.newValue2 || item.newValue2.length == 0)) {
            ElMessage.warning("请选择" + item.name);
            return false;
          }
        }
        if (item.formatType == 1) {
          if (!item.newValue1 || item.newValue1.length == 0) {
            ElMessage.warning("请上传" + item.name);
            return false;
          }
        }
        return true;
      };

      for (let i = 0; i < qualificationList.value.length; i++) {
        const item = qualificationList.value[i];
        if (isChanged(item) && !validateItem(item)) return;
        for (let j = 0; j < item.children.length; j++) {
          const child = item.children[j];
          if (isChanged(child) && !validateItem(child)) return;
        }
      }

      // 构建提交数据（仅传有变更的项）
      const updateItems = [];
      const isResubmit =
        qualificationState.value == 3 || qualificationState.value == 4;

      qualificationList.value.forEach((item) => {
        if (isResubmit) {
          if (item.auditStatus == 2 && isChanged(item)) {
            updateItems.push(buildItem(item));
          }
        } else {
          if (isChanged(item)) {
            updateItems.push(buildItem(item));
          }
        }
        item.children.forEach((child) => {
          if (isResubmit) {
            if (child.auditStatus == 2 && isChanged(child)) {
              updateItems.push(buildItem(child));
            }
          } else {
            if (isChanged(child)) {
              updateItems.push(buildItem(child));
            }
          }
        });
      });

      const params = {
        memberEnterpriseId: memberEnterpriseId.value,
        enterpriseName: enterpriseName.value,
        updateItems: updateItems,
        thisRemark: thisRemark.value,
        memberReceiveAddressOa: {
          addressAll: cascaderAddr.value ? cascaderAddr.value.getCheckedNodes()[0].pathLabels.join("") : '',
          provinceCode: memberListInfo.area[0] || '',
          cityCode: memberListInfo.area[1] || '',
          districtCode: memberListInfo.area[2] || '',
          receiveName: memberListInfo.receiveName,
          receiveTel: memberListInfo.contactMobile,
          detailAddress: memberListInfo.addressDetail,
        },
      };

      const url = isResubmit
        ? "/v3/member/front/memberEnterPrise/apply/resubmitUpdate"
        : "/v3/member/front/memberEnterPrise/apply/submitUpdate";

      gologin_flag.value = true;
      proxy.$post(url, params, "json").then((res) => {
        gologin_flag.value = false;
        if (res.state == 200) {
          ElMessageBox.confirm(
            "经营信息已提交，请耐心等待审核结果，详情可咨询商城客服",
            "温馨提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "关闭",
              type: "success",
            }
          ).then(() => {
            router.replace("/member/index");
          });
        } else {
          ElMessage.warning(res.msg);
        }
      });
    };

    onMounted(() => {
      getUpdateCompare();
    });

    return {
      loading,
      errorMsg,
      gologin_flag,
      enterpriseName,
      enterpriseTypeName,
      enterpriseTypeId,
      memberEnterpriseId,
      qualificationList,
      memberListInfo,
      cascaderAddr,
      cascaderProps,
      areaDataArray,
      thisRemark,
      locale,
      disabledDate,
      getUpdateCompare,
      changepic,
      close_img,
      cardInp,
      aptit_radio,
      go_tem,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/businessInfoUpdate.scss";
</style>